module.exports = __webpack_public_path__ + "static/media/33.f72d1295.jpg";